import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
// import { AuthGuard } from './auth.guard';
// import { AuthGuard, redirectUnauthorizedTo, canActivate } from '@angular/fire/auth-guard';
import { ValidateUserDataGuard } from './auth.guard';
import { ThreeViewerComponent } from './components/three-viewer/three-viewer.component';
import { DesignEngineComponent } from './components/design-engine/design-engine.component';
import { OrderDetailsComponent } from './components/order-details/order-details.component';
import { FaqComponent } from './components/faq/faq.component';
import { CreateCustomFormComponent } from './components/create-custom-form/create-custom-form.component';
import { AnalysisDetailsComponent } from './components/analysis-details/analysis-details.component';
import { AnalysisDetailsReportPdfComponent } from './components/analysis-details-report-pdf/analysis-details-report-pdf.component';
import { ManufacturingComponent } from './components/manufacturing/manufacturing.component';
import { AnalyticsComponent } from './components/analytics/analytics.component';
import { OrderCreateDesignEngineComponent } from './components/order-create-design-engine/order-create-design-engine.component';
import { ViewCustomFormComponent } from './pages/view-custom-form/view-custom-form.component';
import { ClinicsComponent } from './components/clinics/clinics.component';
import { UsersComponent } from './components/users/users.component';
import { CustomFormsComponent } from './pages/custom-forms/custom-forms.component';
import { CustomFormDetailsComponent } from './components/custom-form-details/custom-form-details.component';
import { SelfScanningInstructionsComponent } from './components/self-scanning-instructions/self-scanning-instructions.component';
import { TermsComponent } from './components/terms/terms.component';
import { PrescriptionTemplatesComponent } from './components/prescription-templates/prescription-templates.component';
import { DistributorAnalyticsDetailComponent } from './pages/distributor-analytics-detail/distributor-analytics-detail.component';
import { ProductsComponent } from './components/products/products.component';
import { VolumentalComponent } from './components/volumental/volumental.component';
import { TensorflowTestComponent } from './components/tensorflow-test/tensorflow-test.component';
import { YoloDetectorComponent } from './components/yolo-detector/yolo-detector.component';
import { SubscriptionSuccessComponent } from './pages/subscription-success/subscription-success.component';

const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    canActivate: [ValidateUserDataGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule),
      },
      {
        path: 'order/:orderId',
        data: {
          title: 'Detailed order',
          urls: [
            { title: 'Detailed Order', url: 'order/:orderId' },
            { title: 'Detailed order' }
          ]
        },
        component: OrderDetailsComponent
      },
      {
        path: 'analysis-details/:orderId/:analysisId',
        data: {
          title: 'Analysis Details',
          urls: [
            { title: 'Analysis Details', url: 'analysis-details' },
            { title: 'Analysis Details' }
          ]
        },
        component: AnalysisDetailsComponent
      },
      {
        path: 'analysis-details-report-pdf/:orderId',
        data: {
          title: 'Analysis Details Report PDF',
          urls: [
            { title: 'Analysis Details Report PDF', url: 'analysis-details-report-pdf' },
            { title: 'Analysis Details Report PDF' }
          ]
        },
        component: AnalysisDetailsReportPdfComponent
      },
      {
        path: 'distributor-analytics-detail/:distributorId',
        data: {
          title: 'Distributor Analytics Detail',
          urls: [
            { title: 'Distributor Analytics Detail', url: 'distributor-analytics-detail' },
            { title: 'Distributor Analytics Detail' }
          ]
        },
        component: DistributorAnalyticsDetailComponent
      },
      {
        path: 'manufacturing',
        data: {
          title: 'Manufacturing',
          urls: [
            { title: 'Manufacturing', url: '/manufacturing' },
            { title: 'Manufacturing Page' }
          ]
        },
        component: ManufacturingComponent
      },
      {
        path: 'analytics',
        data: {
          title: 'Analytics',
          urls: [
            { title: 'Analytics', url: '/analytics' },
            { title: 'Analytics Page' }
          ]
        },
        component: AnalyticsComponent,
      },
      {
        path: 'create-order-design-engine',
        data: {
          title: 'Order creation - Prepare 3D order',
          urls: [
            { title: 'Order creation - Prepare 3D order', url: 'create-order-design-engine' },
            { title: 'Order creation - Prepare 3D order' }
          ]
        },
        component: OrderCreateDesignEngineComponent
      },
      {
        path: 'clinics',
        data: {
          title: 'Clinics',
          urls: [
            { title: 'Clinics', url: '/clinics' },
            { title: 'Clinics Page' }
          ]
        },
        component: ClinicsComponent
      },
      {
        path: 'users',
        data: {
          title: 'Users',
          urls: [
            { title: 'Users', url: '/users' },
            { title: 'Users Page' }
          ]
        },
        component: UsersComponent
      },
      {
        path: 'custom-form/:id',
        data: {
          title: "Custom Form Details",
          urls: [
            { title: 'Custom Form Details', url: '/custom-form-details' },
            { title: 'Custom Form Details' }
          ]
        },
        component: CustomFormDetailsComponent,
        canActivate: []
      },
      {
        path: 'prescription-templates',
        data: {
          title: 'Prescription templates',
          urls: [
            { title: 'Prescription templates', url: '/prescription-templates' },
            { title: 'Prescription templates page' }
          ]
        },
        component: PrescriptionTemplatesComponent
      },
      {
        path: 'products',
        data: {
          title: 'Products',
          urls: [
            { title: 'Products', url: '/products' },
            { title: 'Products page' }
          ]
        },
        component: ProductsComponent
      },
      {
        path: 'tensorflow-test',
        data: {
          title: 'TensorFlow Test',
          urls: [
            { title: 'TensorFlow Test', url: '/tensorflow-test' },
            { title: 'TensorFlow Test page' }
          ]
        },
        component: TensorflowTestComponent
      },
      {
        path: 'yolo-detector',
        data: {
          title: 'YOLO Detector',
          urls: [
            { title: 'YOLO Detector', url: '/yolo-detector' },
            { title: 'YOLO Detector page' }
          ]
        },
        component: YoloDetectorComponent
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
    ],
  },
  {
    path: 'viewer/:scanId',
    data: {
      title: '3D Viewer',
      urls: [
        { title: '3D viewer', url: '/editor:/scanId' },
        { title: '3D Viewer page' }
      ]
    },
    component: ThreeViewerComponent
  },
  {
    path: 'viewer/:scanId/:fileName',
    data: {
      title: '3D Viewer',
      urls: [
        { title: '3D viewer', url: '/editor:/scanId' },
        { title: '3D Viewer page' }
      ]
    },
    component: ThreeViewerComponent
  },
  {
    path: 'design/design-engine',
    data: {
      title: '3D Design Engine',
      urls: [
        { title: '3D Design Engine', url: 'design-engine' },
        { title: '3D Design Engine' }
      ]
    },
    component: DesignEngineComponent
  },
  ,
  {
    path: 'faq',
    data: {
      title: 'FAQ',
      urls: [
        { title: 'FAQ', url: 'faq' },
        { title: 'FAQ' }
      ]
    },
    component: FaqComponent
  },
  {
    path: 'terms',
    data: {
      title: 'Terms',
      urls: [
        { title: 'Terms', url: 'terms' },
        { title: 'Terms' }
      ]
    },
    component: TermsComponent
  },
  {
    path: 'custom-forms',
    data: {
      title: 'Custom Forms',
      urls: [
        { title: 'Custom Forms', url: 'custom-forms' },
        { title: 'Custom Forms' }
      ]
    },
    component: CreateCustomFormComponent
  },
  {
    path: 'view-custom-form/:id',
    data: {
      title: "Customer Components",
      urls: [
        { title: 'Customer Components', url: '/customer-components' },
        { title: 'Customer Components' }
      ]
    },
    component: ViewCustomFormComponent,
    canActivate: []
  },
  {
    path: 'custom-form/view-custom-form/:id',
    data: {
      title: "Customer Components",
      urls: [
        { title: 'Customer Components', url: '/customer-components' },
        { title: 'Customer Components' }
      ]
    },
    component: ViewCustomFormComponent,
    canActivate: []
  },
  {
    path: 'self-scanning-instructions/:scanId',
    data: {
      title: "Self scanning instructions",
      urls: [
        { title: 'Self scanning instructions', url: '/self-scanning-instructions' },
        { title: 'Self scanning instructions' }
      ]
    },
    component: SelfScanningInstructionsComponent,
    canActivate: []
  },
  {
    path: 'web-3d-scan/:prescriptionTemplateId',
    data: {
      title: "Web 3D Scan",
      urls: [
        { title: 'Web 3D Scan', url: '/web-3d-scan' },
        { title: 'Web 3D Scan' }
      ]
    },
    component: VolumentalComponent,
    canActivate: []
  },
  {
    path: 'volumental',
    data: {
      title: "Web 3D Scan",
      urls: [
        { title: 'Web 3D Scan', url: '/volumental' },
        { title: 'Web 3D Scan' }
      ]
    },
    component: VolumentalComponent,
    canActivate: []
  },
  {
    path: 'success',
    data: {
      title: "Subscription Success",
      urls: [
        { title: 'Subscription Success', url: '/success' },
        { title: 'Subscription Success' }
      ]
    },
    component: SubscriptionSuccessComponent,
    canActivate: []
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
